var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAfterBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1451_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.728 4.21001L10.8058 4.27334L14.1391 7.60668L14.1803 7.65334L14.2269 7.72223L14.2603 7.7889L14.2825 7.85779L14.2958 7.92001L14.3014 8.00001L14.298 8.0589L14.2825 8.14223L14.2603 8.21223L14.2025 8.31557L14.1514 8.3789L10.8058 11.7267C10.7078 11.8251 10.5765 11.8833 10.4378 11.8897C10.2991 11.8961 10.1629 11.8503 10.0563 11.7614C9.94962 11.6724 9.88014 11.5467 9.86155 11.4091C9.84295 11.2715 9.87658 11.1319 9.95581 11.0178L10.0191 10.94L12.4047 8.55557H2.6347C2.49588 8.55582 2.36198 8.50409 2.25939 8.41056C2.1568 8.31702 2.09294 8.18847 2.0804 8.05021C2.06785 7.91195 2.10753 7.774 2.19162 7.66353C2.2757 7.55306 2.3981 7.47808 2.5347 7.45334L2.6347 7.44445H12.4047L10.0191 5.06001C9.92729 4.96795 9.87064 4.84658 9.85906 4.71704C9.84749 4.5875 9.88173 4.45801 9.95581 4.35112L10.0191 4.27334C10.0995 4.19332 10.2023 4.13978 10.314 4.11992C10.4256 4.10006 10.5406 4.11482 10.6436 4.16223L10.728 4.21001Z",
    fill: "#122F49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1451_51"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.19043)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterBlack);
export default __webpack_public_path__ + "static/media/afterBlack.42424e1548c675627faf36a4e2a12d80.svg";
export { ForwardRef as ReactComponent };